<div class="pricing-container" *ngIf="productItem">
  <!-- Cost Price -->
  <div class="price-section">
    <div class="price-amount">{{ costPrice }}</div>
    <div class="price-label">Cost Price</div>
  </div>

  <!-- Selling Price (with VAT) -->
  <div class="price-section">
    <div class="price-amount">{{ sellingPrice }}</div>
    <div class="price-label">Selling Price (with VAT)</div>
  </div>

  <!-- Displayed Price -->
  <div class="price-section">
    <div class="price-amount">{{ displayedPrice }}</div>
    <div class="price-label">Displayed Price</div>
  </div>
</div>
